import $ from 'jquery'
import { formatNumberCompact } from './number-display'
import { parseBackendTimestamp } from './backend-timestamp'

import EnteteBonEtFacture from '@/views/en-tete-bon-facture';
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
import excel from 'vue-excel-export'
 
Vue.use(excel)
Vue.use(VueHtml2pdf)

import { cca_config }  from '@/plugins/cca-config'

export const utilMixins = {
    components: {
        EnteteBonEtFacture
    },
    data() {
        return {
            assets_path: cca_config.C_URL+cca_config.C_URL_ASSET,

            base_url_caisse: cca_config.C_CAISSE_FE_URL,
            base_url_stock: cca_config.C_STOCK_FE_URL,
            base_url_rh: cca_config.C_RH_FE_URL,

            foot_1: '',
            foot_2: '',
            foot_3: '',
            is_printing: false,
            
            info_currency: {},
            principal_currency: '',
            secondary_currency: '',
            currency_lang: '',
            has_two_currencies: '',
            currency_info: {
                principal_currency: 'F.CFA',
                secondary_currency: '',
                rate: ''
            },

            is_exporting: false,
            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ],
            list_months: [
                { id: '', lib: "Choisir" }, 
                { id: 1, lib: "Janvier" }, { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" }, { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" }, { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" }, { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" }, { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" }, { id: 12, lib: "Décembre" },
            ],
            current_date: new Date(),

            nom_clinique: '',
            logo_clinique: '',
            has_info: false,
            info_clinique: {
                'logo': '', 'type_centre': '', 'nom': '',
                'pays': '', 'fuseau_horaire': '', 'ville': '', 'adresse': '', 'specialites': '',
                'code_autorisation': '', 'entete': ''
            },
            default_country_code: '', 
            ville: '',
            is_sfe: '',
            is_modele_analyse: '',

            C_URL: cca_config.C_URL,
            C_URL_CLINIQUE_API: cca_config.C_URL_CLINIQUE_API,
            C_URL_CAISSE_API: cca_config.C_URL_CAISSE_API,
            C_URL_CONFIG_API: cca_config.C_URL_CONFIG_API,
            C_URL_STOCK_API: cca_config.C_URL_STOCK_API,
        }
    },

    created() {
        this.info_clinique = this.$store.getters["config_info_clinique"]
        this.info_currency = this.$store.getters["info_currency"] || {}
        
        // document.title = cca_config.VUE_APP_NAME
    
        document.title = cca_config.VUE_APP_NAME || 'Clinicaa' 
        // document.title = this.info_clinique.nom ? this.info_clinique.nom+' | '+' Clinique' : 'Clinicaa'
    },

    computed: {
        can_set_pac() {
            const value = (this.$store.getters.config_info_clinique || {}).can_set_pac
            return value === true || value === 1 || ['1', 'true', 'on', 'yes'].includes(String(value).trim().toLowerCase())
        },
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            let m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        // config_info_clinique() {
        //     console.log('3');
        //     return this.$store.getters["config_info_clinique"];
        // },
    },

    mounted() {
        this.checkInfoClinique()
    },

    methods: {
        formatNumberCompact,
        checkInfoClinique() {
            this.has_info = this.info_clinique.has_info
            this.nom_clinique = this.info_clinique.nom
            this.logo_clinique = this.info_clinique.logo
            this.ville = this.info_clinique.ville
            this.default_country_code = this.info_clinique.code_pays
            this.is_sfe = this.info_clinique.is_sfe
            this.is_modele_analyse = this.info_clinique.is_modele_analyse

            // Currency info
            this.principal_currency = this.info_currency.label_principal_currency
            this.secondary_currency = this.info_currency.label_secondary_currency
            this.currency_lang = this.info_currency.currency_lang
            this.has_two_currencies = this.info_currency.has_two_currencies
            this.currency_info = {
                principal_currency: this.info_currency.principal_currency,
                secondary_currency: this.info_currency.secondary_currency,
                rate: this.info_currency.rate
            }
        },

        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigits(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9]+/g, ''))
        },

        formatCurrency(num) {
            return new Number(num).toLocaleString(this.currency_lang);
        },

        transformToNumber(value) {
            return +value
        },

        capitalizeFirstLetter(value) {
            return value[0]
        },

        /**
         * Uniformise l'abréviation visible du sexe sans modifier la donnée
         * métier ou les anciennes valeurs conservées dans les dossiers.
         */
        formatSexeCourt(value, fallback = '—') {
            const rawValue = value && typeof value === 'object'
                ? (value.specificatif || value.description || value.libelle || '')
                : value
            const raw = rawValue == null ? '' : String(rawValue).trim()
            const normalized = raw
                .toLocaleLowerCase('fr-FR')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')

            if (['h', 'm', 'homme', 'masculin', 'masculine', 'male'].includes(normalized)) return 'M'
            if (['f', 'femme', 'feminin', 'feminine', 'female'].includes(normalized)) return 'F'

            return raw || fallback
        },

        shortenString(value) {
            let shorten_string = value
            // let len = value.length

            // if (len > s_len) {
            //     shorten_string = value.substr(0, s_len)+'...'
            // }

            return shorten_string
        },

        toggleCollapse(selector) {
            const el = document.getElementById(selector)
            const hd = document.querySelectorAll(".section-box")
            
            if (hd != null) {
                for (let i = 0; i < hd.length; ++i) {
                    hd[i].classList.remove('show');
                }
            }
            
            el.classList.add('show')
        },

        /**
         * Email validator
         * @param {*} email 
         * @returns 
         */
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        goTo(url) {
            this.$router.push({"path": url})

            let path = this.$route.path
            
            this.is_param = path.includes("parametres")
        },

        successToast: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        errorToast: function(message) {
            this.$toasted.show(message, {
                duration: 4000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-danger',
                type: 'danger',
                position: 'top-center'

            })
        },

        warningToast: function (message) {
            this.$toasted.show(message, {
                duration: 4000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                theme: "toasted-warning",
                type: "warning",
                position: "top-center",
            });
        },

        getDates() {
            let now = new Date();
            let yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);

            let today = this.getDatePartsInClinicTimezone(now);
            let before = this.getDatePartsInClinicTimezone(yesterday);

            let today_date = `${today.year}-${Number(today.month)}-${Number(today.day)}`;
            let yesterday_date = `${before.year}-${Number(before.month)}-${Number(before.day)}`;
            return { today_date, yesterday_date };
        },

        /**
         * Fuseau horaire configuré pour la clinique (Établissement > Fuseau horaire).
         * Retombe sur le fuseau du navigateur tant qu'aucun fuseau n'a été choisi,
         * pour ne pas changer le comportement des installations non configurées.
         * @returns {string} identifiant IANA (ex. "Africa/Kinshasa")
         */
        getClinicTimezone() {
            const info = this.$store && this.$store.getters && this.$store.getters['config_info_clinique']
            return (info && info.fuseau_horaire)
                || (this.info_clinique && this.info_clinique.fuseau_horaire)
                || Intl.DateTimeFormat().resolvedOptions().timeZone
        },

        /**
         * Décompose une date dans le fuseau horaire de la clinique, quel que soit
         * le fuseau horaire du poste/navigateur qui l'affiche.
         * @param {Date} date
         * @returns {{year: string, month: string, day: string, hour: string, minute: string}}
         */
        getDatePartsInClinicTimezone(date) {
            const parts = {}
            new Intl.DateTimeFormat('fr-FR', {
                timeZone: this.getClinicTimezone(),
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit', hour12: false
            }).formatToParts(date).forEach(({ type, value }) => {
                parts[type] = value
            })
            // hour12: false renvoie parfois "24" pour minuit selon le moteur JS
            if (parts.hour === '24') parts.hour = '00'

            return parts
        },

        formatDateToDateHour(given_date) {
            if (given_date === null || given_date === undefined || given_date === '') return '—'
            let date = parseBackendTimestamp(given_date);
            if (Number.isNaN(date.getTime())) return '—'
            let { day, month, year, hour, minute } = this.getDatePartsInClinicTimezone(date)

            return day + "/" + month + "/" + year + " à " + hour + "h" + minute;
        },

        /**
         * Forma to date to dd/mm/yyyy
         * @param {*} dateStr
         * @returns
         */
        formatDateToDmY: function(dateStr){
            let date = parseBackendTimestamp(dateStr)
            let { day, month, year } = this.getDatePartsInClinicTimezone(date)

            return day + '/' + month + '/' + year;
        },

        /**
         * Forma to date to Y-m-d
         * @param {*} dateStr
         * @returns
         */
         formatDateToYmD: function(dateStr){
            let date = parseBackendTimestamp(dateStr)
            let { day, month, year } = this.getDatePartsInClinicTimezone(date)

            return year + '-' + month + '-' + day;
        },

        /**
         * Format hour to HHhmm (HH = Hour - mm = minute)
         * @param {*} dateStr
         * @returns
         */
        formatHourToHm: function(dateStr){
            let date = parseBackendTimestamp(dateStr)
            let { hour, minute } = this.getDatePartsInClinicTimezone(date)

            return hour + 'h' + minute
        },

        /**
         * Format hour to HHhmm (HH = Hour - mm = minute)
         * @param {*} dateStr
         * @returns
         */
        formatEnHour: function(dateStr){
            let date = parseBackendTimestamp(dateStr)
            let { hour, minute } = this.getDatePartsInClinicTimezone(date)

            return hour + ':' + minute
        },

        formatBasicHour(hour) {
            let h = hour.replace(':', 'h')
            return h
        },

        setDates() {
            let now = new Date();
            let yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);

            let today = this.getDatePartsInClinicTimezone(now);
            let before = this.getDatePartsInClinicTimezone(yesterday);

            let today_date = `${today.year}-${Number(today.month)}-${Number(today.day)}`;
            let yesterday_date = `${before.year}-${Number(before.month)}-${Number(before.day)}`;
            return { today_date, yesterday_date };
        },

        formatJson(data){
            try {
               return JSON.parse(data)
            } catch(e){
                return data
            }
        },

        /**
         * Ajoute un caractère (Exple. / ou ° etc.) après n chiffres
         * @param {*} n 
         * @param {} selector (est l'ID du champ input)
         */
         async formatNumberToSeparable(n, selector) {
            let nb_car = $('#' + selector).val().length;
            if (n == '1') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9m ]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + 'm ');
                }
            } else if (n == '2') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9^C°]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + '°');
                }else if (nb_car == 4) {
                    $('#' + selector).val($('#' + selector).val() + 'C');
                }
                // this.constantes.temperature = $('#' + selector).val()
            }  else if (n == '3') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9/]+/g, ''))

                if (nb_car == 2) {
                    $('#' + selector).val($('#' + selector).val() + '/');
                }
            }
        },

        printPDF(html2PdfRef = 'html2Pdf') {
            this.is_printing = true
            
            if (this.$refs[html2PdfRef]) {
                this.$refs[html2PdfRef].generatePdf()
            }
        },

        async beforeDownload({ html2pdf, options, pdfContent }, format, is_medical_prescription=false) {
            const newOptions = {
                ...options,
                pagebreak: {
                    mode: ['avoid-all']
                },
            }

            await html2pdf().set(newOptions).from(pdfContent).set(
                {
                    margin: [0.2, 0, 1, 0], 
                }
            ).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                this.getFooter(is_medical_prescription)

                const page_size = pdf.internal.pageSize.getWidth()
                const page_height = pdf.internal.pageSize.getHeight()
                
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)

                    // pdf.setFont('Arial', 'B', 8)
                    if (format == 'a4') {
                        pdf.setFontSize(10)
                        pdf.text(this.foot_1, (page_size / 2), (page_height - 0.5), {align: 'center'})
                        pdf.text(this.foot_2, (page_size / 2), (page_height - 0.3), {align: 'center'})
                    } else if (format == 'a5') {
                        pdf.setFontSize(8)
                        pdf.text(this.foot_1, (page_size / 2), (page_height - 0.7), {align: 'center'})
                        pdf.text(this.foot_2, (page_size / 2), (page_height - 0.5), {align: 'center'})
                        pdf.text(this.foot_3, (page_size / 2), (page_height - 0.3), {align: 'center'})
                    }
                } 
            }).save().then(() => {
                this.is_printing = false
            })
        },

        getFooter(is_medical_prescription) {
            // EPHATA
            this.foot_1 = cca_config.FOOT_1 || ''
            this.foot_2 = cca_config.FOOT_2 || ''

            if (is_medical_prescription) {
                this.foot_3 = cca_config.FOOT_ORD || ''
            }
        },

        hasDownloaded() {},

        onProgress() { },

        startPagination() {},

        hasPaginated() {},

        /**
         * Uplaod file validator
         * @param max_file_size 
         * @returns 
         */
        fileValidation(max_file_size, selector) {
            $('.err-fsize').fadeOut(500)
            $('.err-extension').fadeOut(500)
            var is_valid = true
            
            var fileInput = document.getElementById(selector),
                filePath = fileInput.value
            
            // Allowing file type
            var allowedExtensions =
                    /(\.png|\.jpg|\.jpeg|\.docx|\.doc|\.xls|\.xlsx|\.ppt|\.pptx|\.pdf)$/i;
                
            if (!allowedExtensions.exec(filePath)) {
                // alert('Invalid file type');
                fileInput.value = '';
                $('.err-extension').fadeIn(500)
                is_valid = false
                return;
            } else {
    
                // Check file size
                if (fileInput.files.length > 0) {
                    for (let i = 0; i < fileInput.files.length; i++) {
                        const fsize = fileInput.files.item(i).size
                        const rlsize = Math.round(( fsize / 1024 ))
  
                        if (rlsize > max_file_size) {
                            $('.err-fsize').fadeIn(500)
                            is_valid = false
                            return;
                        } 
                    }
                }
            }

            return is_valid
        },

        /**
         * Set UID for an array of prestation
         * @param {Array} prestations  
         */
        setPrestationUID(prestations) {
            prestations.forEach((analyse, index) => {
                const tm = new Date()
                let tmp_uid = analyse.nom
                tmp_uid = tmp_uid.replace(" ", "_")
                tmp_uid = tmp_uid.replace("/", "_")
                tmp_uid = tmp_uid.toLowerCase()+''+tm.getTime()
                tmp_uid = tmp_uid.replace("  ", "_")
                tmp_uid = tmp_uid.replace(" ", "_")
                prestations[index]['uid'] = tmp_uid
            });
            return prestations
        },

        handleBeforeFinish() {
            this.is_exporting = false
        },

        /**
         * Remove special character from string
         */
        removeAccents(strAccents){
            strAccents = strAccents.split('');
            let strAccentsOut = new Array();
            let strAccentsLen = strAccents.length;
            let accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
            let accentsOut = [
                'A','A','A','A','A','A','a','a','a','a','a','a','O','O','O','O','O','O','O','o',
                'o','o','o','o','o','E','E','E','E','e','e','e','e','e','C','c','D','I','I','I','I',
                'i','i','i','i','U','U','U','U','u','u','u','u','N','n','S','s','Y','y','y','Z','z'
            ];
            for (let y = 0; y < strAccentsLen; y++) {
                if (accents.indexOf(strAccents[y]) != -1) {
                    strAccentsOut[y] = accentsOut[accents.indexOf(strAccents[y])];
                }
                else
                    strAccentsOut[y] = strAccents[y];
            }
            strAccentsOut = strAccentsOut.join('');
            return strAccentsOut;
        },

        generateBasicUID(value) {
            let tmp_uid = value

            tmp_uid = tmp_uid.toLowerCase()
            tmp_uid = tmp_uid.replace("'", "")
            tmp_uid = tmp_uid.replace(" ", "_")
            tmp_uid = tmp_uid.replace("/", "_")
            
            tmp_uid = this.removeAccents(tmp_uid)
            return tmp_uid
        },

        /**
         * Validate a string not to be empty
         * @param {*} value 
         */
        validateStringNotEmpty(value) {
            if (typeof value  === 'string') {
                if (value.trim().length === 0) {
                    return true
                }
            }
            return false
        },

        cleanNumber(value) {
            if (this.validateStringNotEmpty(value)) {
                return ''
            }
            value = this.transformToNumber(value)
            if (!this.validateNumber(value)) {
                return ''
            }
            return value
        },

        validateNumber(number) {
            if (isNaN(number) || typeof number !== 'number') {
              return false
            }
            return true
        },

        removeListElement(obj, index) {
            obj.splice(index, 1)
        },

        getFileType(filename) {
            let file_type = 'autre'
            if (
                filename.includes('png') || 
                filename.includes('PNG') || filename.includes('jpeg') || filename.includes('JPEG') || 
                filename.includes('jpg') || filename.includes('JPG') 
            ) {
                file_type = 'image'
            } else if (filename.includes('pdf')) {
                file_type = 'pdf'
            }
            return file_type
        },
    }
}
